import { Person, IPerson } from '@/classes/InjuryForm/Person';
import TreatmentInformation from '@/classes/InjuryForm/TreatmentInformation';

interface IEmployee extends IPerson {
    userId?: number;
    onDuty?: boolean;
    occupation?: string;
    ubcId?: string;
    offsiteTreatment?: TreatmentInformation;
    dutyStation?: number;
    workStartTime?: string;
    workEndTime?: string;
    workDays?: string[];
    workStopped?: boolean;
    workStoppedDate?: string;
    workReturned?: string;
    workReturnedDate?: string;
    jobCorpCenterId?: number;
}

class Employee extends Person implements IEmployee {
    public userId?: number;
    public onDuty?: boolean;
    public occupation?: string;
    public ubcId?: string;
    public offsiteTreatment?: TreatmentInformation;
    public dutyStation?: number;
    public workStartTime?: string;
    public workEndTime?: string;
    public workDays?: string[];
    public workStopped?: boolean;
    public workStoppedDate?: string;
    public workReturned?: string;
    public workReturnedDate?: string;

    constructor(e: IEmployee = {}) {
        super(e);
        this.userId = e.userId;
        this.onDuty = e.onDuty;
        this.occupation = e.occupation;
        this.ubcId = e.ubcId;
        this.offsiteTreatment = new TreatmentInformation(e.offsiteTreatment);
        this.dutyStation = e.dutyStation;
        this.workStartTime = e.workStartTime;
        this.workEndTime = e.workEndTime;
        this.workDays = e.workDays;
        this.workStopped = e.workStopped;
        this.workStoppedDate = e.workStoppedDate;
        this.workReturned = e.workReturned;
        this.workReturnedDate = e.workReturnedDate;
    }

    public isValid(): boolean {
        if (this.cellPhone) {
            if (this.cellPhone.length >= 14) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    public isSupervisorTabValid(): string[] {
        const validations: string[] = [];
        if (this.onDuty === undefined) {
            validations.push('onDuty');
        }
        if (this.dutyStation === undefined) {
            validations.push('dutyStation');
        }
        if (this.workStartTime === undefined || this.workStartTime.length === 0 ) {
            validations.push('workStartTime');
        }
        if (this.workEndTime === undefined || this.workEndTime.length === 0 ) {
            validations.push('workEndTime');
        }
        if (this.workDays === undefined || this.workDays.length === 0 ) {
            validations.push('workDays');
        }
        if (this.workStopped) {
            if (this.workStoppedDate === undefined || this.workStoppedDate.length === 0 ) {
                validations.push('workStoppedDate');
            }
            if (this.workReturned === undefined) {
                validations.push('workReturned');
            } else {
                if (this.workReturned === 'returned') {
                    if (this.workReturnedDate === undefined || this.workReturnedDate.length === 0) {
                        validations.push('workReturnedDate');
                    }
                }
            }
        }
        return validations;
    }
}

export default Employee;
export { Employee, IEmployee };
